import axios from "axios";
import store from "@/store";
import Router from "vue-router";
import config from "@/config";
import {matchRegExps,getDevice} from "./utils";

const {appId} = config;

class HttpRequest {
    constructor(baseUrl = baseURL) {
        this.baseUrl = baseUrl;
        this.queue = {};
    }

    getInsideConfig() {
        const userId = store.state.userinfo.id || sessionStorage.getItem("USER_ID");
        // console.info('userId',typeof  userId,userId)
        // console.info('store.state',store.state.userinfo.id)
        const config = {
            baseURL: this.baseUrl,
            headers: {
                appId,
                userId,
                source:getDevice()
            }
        };
        return config;
    }

    destroy(url) {
        delete this.queue[url];
        if (!Object.keys(this.queue).length) {
            // Spin.hide()
        }
    }

    interceptors(instance, url) {
        // 请求拦截
        instance.interceptors.request.use(config => {
            // 添加全局的loading...
            if (!Object.keys(this.queue).length) {
                // Spin.show() // 不建议开启，因为界面不友好
            }
            this.queue[url] = true;
            return config;
        }, error => {
            return Promise.reject(error);
        });
        // 响应拦截
        instance.interceptors.response.use(res => {
            this.destroy(url);
            const {data, status} = res;
            return {data, status};
        }, error => {
            this.destroy(url);
            let errorInfo = error.response;
            if (!errorInfo) {
                const {request: {statusText, status}, config} = JSON.parse(JSON.stringify(error));
                errorInfo = {
                    statusText,
                    status,
                    request: {responseURL: config.url}
                };
            }
            return Promise.reject(error);
        });
    }

    request(options) {

        if (!matchRegExps("/search", options.url) && !matchRegExps( options.url,"/set-position")) {
            setTimeout(() => {
                store.commit("setViewFade", false);
            }, 0);
        }
        if (!matchRegExps( options.url,'/set-position')) {
            // setTimeout(() => {
            //     store.commit("setMaskShowStatus", true);
            // }, 0);
        }

        const instance = axios.create();
        options = Object.assign(this.getInsideConfig(), options);
        this.interceptors(instance, options.url);
        return instance(options);
    }
}

export default HttpRequest;
